<div class="select-only-items__items">
  @for (item of selectOnlyComponent.items; track item) {
    <div class="select-only-items__item" (click)="selectOnlyComponent.select(item)">
      {{ item.name }}
    </div>
  }
</div>
<!--[class.select-only-items__item_active]="item.id && item.id === selectOnlyComponent.value"-->
